import { render, staticRenderFns } from "./LoginLink.vue?vue&type=template&id=1af53b8a"
import script from "./LoginLink.vue?vue&type=script&lang=ts"
export * from "./LoginLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports